import _ from 'underscore';
import queryString from 'query-string';
import { VideoStatus, AdditionalQueries } from './constants';
import { EntryCardSVGIcons } from '../../src/asset-images';

// TO DO: update this when new entity type is created
const ExternalEntityType = {
  XandrAdvertiser: 8,
};

export const checkVideosIntermediateStatus =
  video => video.status !== VideoStatus.Active && video.status !== VideoStatus.Failed;
/* istanbul ignore next */
const getSizeLimitPerAccount = (aid, id) => {
  const value = localStorage.getItem(`SystemLimitData_${aid}`);
  if (!value) {
    return null;
  }

  let valObj = null;

  try {
    valObj = JSON.parse(value);
  } catch (e) {
    return null;
  }

  const limitData = _.find(valObj.data, data => data.id === id);

  return limitData && limitData.val;
};

export const isValidXandrAccount = (account) => {
  if (account && account.ExternalAccountIds && account.ExternalAccountIds.length > 0) {
    // TO DO switch this to new enetity type when its available
    const externalAccountId = _.find(account.ExternalAccountIds, item => item.Type === ExternalEntityType.XandrAdvertiser);
    return externalAccountId !== undefined && externalAccountId.Id !== null && externalAccountId.Id !== undefined;
  }
  // TO DO switch to false
  return true;
};

export const getEntryCardData = ({
  i18n,
  cardKeys = [],
  onClickCreate = _.noop,
  onClickUpload = _.noop,
  onClickStock = _.noop,
  onClickInvest = _.noop,
  onClickWebsite = _.noop,
  isImagePage = false,
  isVideoPage = false,
  isXandrIntegrationEnabled = false,
}) => {
  let uploadDescription = i18n.getString(_TL_('Upload assets from your computer'));
  let websiteDescription = i18n.getString(_TL_('Enter your URL and we\'ll pull assets from it'));
  let websiteTitle = i18n.getString(_TL_('Add from website'));
  let createDescription = i18n.getString(_TL_('Create AI-generated images'));
  let createTitle = i18n.getString(_TL_('Create'));
  let investDescription = i18n.getString(_TL_('Search Invest'));
  if (isImagePage) {
    createDescription = i18n.getString(_TL_('Create AI-generated images'));
    uploadDescription = i18n.getString(_TL_('Upload images from your computer'));
    websiteDescription = i18n.getString(_TL_('Enter your URL and we\'ll pull images from it'));
    investDescription = i18n.getString(_TL_('Search Invest for images'));
  } else if (isVideoPage) {
    createTitle = i18n.getString(_TL_('Create'));
    createDescription = i18n.getString(_TL_('Create a video using a template'));
    uploadDescription = i18n.getString(_TL_('Upload videos from your computer'));
    websiteDescription = i18n.getString(_TL_('Enter your video\'s URL'));
    websiteTitle = i18n.getString(_TL_('Add from URL'));
    investDescription = i18n.getString(_TL_('Search Invest for videos'));
  }

  let cardData = [
    {
      title: createTitle,
      description: createDescription,
      image: EntryCardSVGIcons.CreateSVGIcon,
      onClick: onClickCreate,
      key: 'Create',
    },
    {
      title: i18n.getString(_TL_('Upload')),
      description: uploadDescription,
      image: EntryCardSVGIcons.UploadSVGIcon,
      onClick: onClickUpload,
      key: 'Upload',
    },
    {
      title: i18n.getString(_TL_('Get stock images')),
      description: i18n.getString(_TL_('Search Shutterstock for images')),
      image: EntryCardSVGIcons.StockSVGIcon,
      onClick: onClickStock,
      key: 'Stock',
    },
    {
      title: websiteTitle,
      description: websiteDescription,
      image: EntryCardSVGIcons.WebsiteSVGIcon,
      onClick: onClickWebsite,
      key: 'Website',
    },
  ];

  if (isXandrIntegrationEnabled) {
    cardData = [
      ...cardData,
      {
        title: i18n.getString(_TL_('Add from Microsoft Invest')),
        description: investDescription,
        image: EntryCardSVGIcons.InvestSVGIcon,
        onClick: onClickInvest,
        key: 'Invest',
      },
    ];
  }


  if (!cardKeys.length) {
    return cardData;
  }
  return cardData.filter(card => cardKeys.includes(card.key));
};

export const getHomePageCardData = ({
  i18n,
  cardKeys = [],
  onClickUpload = _.noop,
  onClickStock = _.noop,
  onClickWebsite = _.noop,
  onClickInvest = _.noop,
  isXandrIntegrationEnabled = false,
}) => {
  let cardData = [
    {
      title: i18n.getString(_TL_('Upload')),
      description: i18n.getString(_TL_('Upload assets from your computer')),
      image: EntryCardSVGIcons.UploadSVGIcon,
      onClick: onClickUpload,
      key: 'Upload',
    },
    {
      title: i18n.getString(_TL_('Add from website')),
      description: i18n.getString(_TL_('Enter your URL and we’ll pull assets from it')),
      image: EntryCardSVGIcons.WebsiteSVGIcon,
      onClick: onClickWebsite,
      key: 'Website',
    },
    {
      title: i18n.getString(_TL_('Get stock images')),
      description: i18n.getString(_TL_('Search Shutterstock for images')),
      image: EntryCardSVGIcons.StockSVGIcon,
      onClick: onClickStock,
      key: 'Stock',
    },
  ];

  if (isXandrIntegrationEnabled) {
    cardData = [
      ...cardData,
      {
        title: i18n.getString(_TL_('Add from Microsoft Invest')),
        description: i18n.getString(_TL_('Search Invest for images')),
        image: EntryCardSVGIcons.InvestSVGIcon,
        onClick: onClickInvest,
        key: 'Invest',
      },
    ];
  }

  if (!cardKeys.length) {
    return cardData;
  }
  return cardData.filter(card => cardKeys.includes(card.key));
};

export const getImageAssetLimitPerAccount = (aid, logger) => {
  const assetLimit = getSizeLimitPerAccount(aid, 32);
  /* istanbul ignore if */
  if (assetLimit) {
    return assetLimit;
  }

  logger.logError('get image asset limit data error', { aid });
  return 5000;
};

export const getFoldersLimitPerAccount = (aid, logger) => {
  const foldersLimit = getSizeLimitPerAccount(aid, 97);
  /* istanbul ignore if */
  if (foldersLimit) {
    return foldersLimit;
  }
  logger.logError('get folders limit data error', { aid });
  return 1000;
};

export const getVideoAssetLimitPerAccount = (aid, logger) => {
  const assetLimit = getSizeLimitPerAccount(aid, 86);
  /* istanbul ignore if */
  if (assetLimit) {
    return assetLimit;
  }

  logger.logError('get video asset limit data error', { aid });
  return 1000;
};

export const validate = (value) => {
  const reg = /<|>|:|\*|\?|"|\\|\/|\|/;
  return !reg.test(value);
};

export const getSearchQuery = ({ search = '', additionalQueries = {}, removeQueries = [] }) => {
  let query = queryString.parse(search);
  query = _.omit(query, (value, key) => _.includes(_.values(AdditionalQueries), key) || _.includes(removeQueries, key));
  query = {
    ...query,
    ...additionalQueries,
  };
  return `?${queryString.stringify(query)}`;
};

export const AIGCHandler = (isAdsStudioAIGCMVPEnabled, isAIGCRegionRestricted, notificationApi, i18n, enabledCallback) => {
  if (isAdsStudioAIGCMVPEnabled && !isAIGCRegionRestricted) {
    enabledCallback();
  } else if (isAIGCRegionRestricted) {
    notificationApi.showWarning(i18n.getString(_TL_('This feature isn\'t available in all markets.')));
  } else {
    notificationApi.showWarning(i18n.getString(_TL_('This feature isn\'t available yet, but it\'s coming soon.')));
  }
};

const getRealUsedFlagValue = (preference, flagSuffix) => {
  if (preference && flagSuffix) {
    const realUsedFlagStr = `realUsedFlagIn${flagSuffix}`;
    const realUsedFlagHandlerStr = `setRealUsedFlagIn${flagSuffix}`;
    const realUsedFlag = preference[realUsedFlagStr];
    const realUsedFlagHandler = preference[realUsedFlagHandlerStr];

    return {
      realUsedFlag,
      realUsedFlagHandler,
    };
  }

  return {};
};

export const handleRealUsedFlag = (preference, flagSuffix) => { // flagSuffix: AssetLibraryApp or AssetLibraryPicker
  const { realUsedFlag, realUsedFlagHandler } = getRealUsedFlagValue(preference, flagSuffix);

  const {
    haveUsed,
  } = realUsedFlag || {};

  if (!haveUsed && realUsedFlagHandler) {
    realUsedFlagHandler();
  }
};

export const addAdStudioSurveyTriggerFlag = (preference, triggerFlag, usedFlagSuffix) => {
  const { realUsedFlag } = getRealUsedFlagValue(preference, usedFlagSuffix);

  const { haveUsed, timestamp } = realUsedFlag || {};

  if (haveUsed) {
    const currentTime = new Date().getTime();
    const diffDay = (currentTime - timestamp) / 1000 / 60 / 60 / 24;
    if (diffDay > 1 && window.survey && window.survey.surveyManager) {
      window.survey[triggerFlag] = true;
      window.survey.surveyManager.trigger({
        checkIfSurveyIsOpen: true,
      });
    }
  }
};

export const removeAdStudioSurveyTriggerFlag = (triggerFlag) => {
  if (window.survey) {
    window.survey[triggerFlag] = false;
  }
};
